import { mapPaneColorBg, mapPanePadding, mapPaneRadius, mapPaneMargin } from './helpers';

const Pane = ({ children, color = 'white', padding = 0, radius = 12, margin = 14 }) => {
  const classNames = `integration__pane ${mapPaneColorBg[color]} ${mapPanePadding[padding]} ${mapPaneRadius[radius]} ${mapPaneMargin[margin]}`;

  return <div className={classNames}>{children}</div>;
};

export default Pane;
